import React from 'react';

import OperatingHours from 'settings/salon/OperatingHours.component';

import BusinessInformation from './BusinessInformation.component';

const SalonOverview = () => (
  <div data-bem="SalonOverview">
    <BusinessInformation />
    <OperatingHours />
  </div>
);

export default SalonOverview;
